import {
  personInfo
} from '../api/home'

const user = {
  state: {
    phone: '',
    change: false
  },

  mutations: {
    SET_PHONE: (state, phone) => {
      state.phone = phone
      state.change = true
    },
  },

  actions: {
    // 获取用户信息
    GetPhone({
      commit
    }) {
      personInfo({
        userId: window.localStorage.getItem('userId'),
        firmId: window.localStorage.getItem('firmId'),
      }).then((res) => {
        commit('SET_PHONE', res.data.tel)
      })
    },
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/user.js